var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 6.5V5C12 4.45 11.55 4 11 4H3C2.45 4 2 4.45 2 5V11C2 11.55 2.45 12 3 12H11C11.55 12 12 11.55 12 11V9.5L14.4 11.3C15.0592 11.7944 16 11.324 16 10.5V5.5C16 4.67595 15.0592 4.20557 14.4 4.7L12 6.5Z",
    fill: "#1A7F5A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.e93f689aec87fa1794d710295278984d.svg";
export { ForwardRef as ReactComponent };